/**
 * L'accord entre les fichiers de l'aperçu plein écran (refonte modulaire §9.1,
 * §9.2, §9.3, §9.5 ; issue #141).
 *
 * Every `data-testid` more than one file reads is declared HERE, exactly as
 * `experiences/contracts.ts` and `page-editor/contracts.ts` do for their own
 * sub-trees. The reason is the same and it is sharper here: the layer is opened
 * from TWO screens - the head of the page editor and the Timeline tab - and it
 * is read by a suite that does not compile the frontend (`e2e/tests/apercu.spec.ts`
 * recopies these strings). A mark spelled in two files would resolve in one
 * screen and not in the other, and nothing would turn red.
 *
 * The prefix is `experience-apercu-` and not `page-apercu-`: `page-apercu` is
 * already taken by the preview COLUMN of the page editor (`PAGE_EDITOR_IDS.preview`),
 * which is a different surface with a different job - it shows one page inside
 * the editor, this one replaces the screen. Two surfaces, two registers, so
 * reading a testid says which of the two wrote it.
 *
 * What is NOT here: the reader's own marks (`lecteur-...`,
 * `components/reader/contracts.ts`), which this layer mounts as they are.
 */
export const EXPERIENCE_PREVIEW_IDS = {
  /** « Aperçu » - the door, beside the Téléphone | Écran toggle of both screens. */
  open: 'experience-apercu-ouvrir',

  /** The layer itself: `fixed inset-0 z-30`, the whole window (see `experience-preview.tsx`). */
  layer: 'experience-apercu',
  /** The box inside the layer that scrolls a page taller than the window (#168). */
  scroll: 'experience-apercu-defilement',

  /**
   * La chrome discrète du haut (`z-40`): the position and the way out.
   *
   * It carries `data-awake` - « on » while it is on screen, « off » once a few
   * seconds without a gesture have faded it away. The attribute and not the
   * class, because a suite that asserts on a Tailwind class asserts on a
   * spelling rather than on a state.
   */
  chrome: 'experience-apercu-chrome',
  /** « Page 3 sur 7 » - counted in the PLAYABLE pages, which is what one walks. */
  position: 'experience-apercu-position',
  /** La croix. `Échap` does the same thing, and the layer wires it by hand. */
  close: 'experience-apercu-fermer',

  /**
   * L'encart de la page protocole (§9.5): « la conversation ne se joue pas en
   * aperçu », plus the name of the protocol the page plays.
   */
  protocolNote: 'experience-apercu-protocole',
} as const;
